import { Map } from 'mapbox-gl';
import { MapEvent } from './map-event';
import { MapEventType } from './map-event-type';

export class MapLoadedMapEvent implements MapEvent {
    type: MapEventType = MapEventType.mapLoaded;
    constructor(public payload: Map) {}
}
